import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';

import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

import AuthGuard from './AuthGuard.jsx';
import RoleGuard from './RoleGaurd.jsx';
import GuestGuard from './GuestGuard.jsx';

// lazy pages
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const UnauthorizedPage = Loadable(lazy(() => import('pages/extra-pages/Unauthorized')));
const SampleBookingPage = Loadable(lazy(() => import('pages/sample-booking/SampleBookingPage')));
const VehicleBrandPage = Loadable(lazy(() => import('pages/vehicle/VehicleBrandPage')));
const VehicleModelPage = Loadable(lazy(() => import('pages/vehicle/VehicleModelPage')));
const UsersPage = Loadable(lazy(() => import('pages/users/UsersPage')));
const VehiclesPage = Loadable(lazy(() => import('pages/vehicle/VehiclesPage')));
const UserViewPage = Loadable(lazy(() => import('pages/users/UserViewPage')));
const UserEditPage = Loadable(lazy(() => import('pages/users/UserDetailPage')));
const VehicleViewPage = Loadable(lazy(() => import('pages/vehicle/VehicleViewPage')));
const VehicleEditPage = Loadable(lazy(() => import('pages/vehicle/VehicleDetailPage')));
const BookingsPage = Loadable(lazy(() => import('pages/bookings/BookingsPage')));
const BookingViewPage = Loadable(lazy(() => import('pages/bookings/BookingViewPage')));
const VendorInsurancePage = Loadable(lazy(() => import('pages/insurance/VendorInsurancePage')));
const VendorInsurancePurchasePage = Loadable(lazy(() => import('pages/insurance/VendorInsurancePurchasePage')));
const CustomerInsurancePage = Loadable(lazy(() => import('pages/insurance/CustomerInsurancePage')));
const InsurancePlanDetailPage = Loadable(lazy(() => import('pages/insurance/InsurancePlanDetailPage')));
const GpsManagementPage = Loadable(lazy(() => import('pages/gps/GpsManagementPage')));
const IncidentsManagementPage = Loadable(lazy(() => import('pages/incidents/IncidentsManagementPage')));
const FeedbackPage = Loadable(lazy(() => import('pages/feedback/FeedbackPage')));
const NotFound = Loadable(lazy(() => import('../pages/404')));

export default function AppRouter() {
  return (
    <Suspense fallback={null}>
      <Routes>
        {/* 🌐 Guest Routes */}
        <Route element={<GuestGuard />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        {/* 🔐 Protected Routes */}
        <Route element={<AuthGuard />}>
          <Route element={<DashboardLayout />}>
            <Route index element={<DashboardDefault />} />
            <Route path="dashboard/default" element={<DashboardDefault />} />
            <Route path="/bookings/create" element={<SampleBookingPage />} />

            <Route element={<RoleGuard roles={['ADMIN', 'Admin', 'Vendor', 'vendor']} />}>
              <Route path="insurance/vendor-subscribe" element={<VendorInsurancePurchasePage />} />
            </Route>

            {/* 👮 Role Protected */}
            <Route element={<RoleGuard roles={['ADMIN','Admin']} />}>
              <Route path="users" element={<UsersPage />} />
              <Route path="users/:id" element={<UserViewPage />} />
              <Route path="users/:id/edit" element={<UserEditPage />} />
              <Route path="bookings" element={<BookingsPage />} />
              <Route path="bookings/:id" element={<BookingViewPage />} />
              <Route path="vehicle/brands" element={<VehicleBrandPage />} />
              <Route path="vehicle/models" element={<VehicleModelPage />} />
              <Route path="vehicles" element={<VehiclesPage />} />
              <Route path="vehicles/:id" element={<VehicleViewPage />} />
              <Route path="vehicles/:id/edit" element={<VehicleEditPage />} />
              <Route path="insurance/vendor-plans" element={<VendorInsurancePage />} />
              <Route path="insurance/vendor-plans/:id" element={<InsurancePlanDetailPage />} />
              <Route path="insurance/customer-plans" element={<CustomerInsurancePage />} />
              <Route path="insurance/customer-plans/:id" element={<InsurancePlanDetailPage />} />
              <Route path="gps/manage" element={<GpsManagementPage />} />
              <Route path="incidents/manage" element={<IncidentsManagementPage />} />
              <Route path="feedback" element={<FeedbackPage />} />
              <Route path="sample-page" element={<SamplePage />} />
            </Route>
          </Route>
        </Route>

        {/* ❌ 404 */}
        <Route path="*" element={<NotFound />} />

        {/* 403 / Unauthorized */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
      </Routes>
    </Suspense>
  );
}
